import React from "react";
import PropTypes from "prop-types";
import { ErrorModalDialog } from "../../uikit";

const ErrorModal = ({
  caption,
  errorMessage,
  onTryAgainClick,
  onCloseClick,
}) => {
  return (
    <ErrorModalDialog
      headerText="Submission Failed"
      messageText={caption}
      submessageText={errorMessage}
      renderActions={() => (
        <a
          className="btn btn-system-alert"
          onClick={(e) => {
            e.preventDefault();
            onTryAgainClick();
          }}
        >
          Try Again
        </a>
      )}
      onClose={onCloseClick}
    />
  );
};

ErrorModal.propTypes = {
  caption: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  onTryAgainClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};

export default ErrorModal;
